<div class="tag" [style]="{
  'background': tag?.backgroundColor,
  'font': tag?.font,
  'height': height,
  'width': width}">
  <p>{{tag?.message}}</p>
</div>
